import { AxiosResponse } from 'axios';
import { bunja } from 'bunja';
import { useBunja } from 'bunja/react';
import { atom, useAtomValue } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';

import { getRegulationApi } from '@flipster/apis/v1/regulation';
import { RegulationResponse, RegulationStatus } from '@flipster/apis/v1/regulation/types';

import { customVaraFlag } from '../../flag';
import { authBunja } from '../auth/state';

export const useCheckSpotOnly = () => {
  const { isSpotOnlyAtom } = useBunja(userRegulationBunja);
  const isSpotOnly = useAtomValue(isSpotOnlyAtom);
  return isSpotOnly;
};

export const userRegulationBunja = bunja(() => {
  const { isCookieLoggedInAtom } = bunja.use(authBunja);

  const isShowAlertAtom = atom(false);

  const getUserRegulationAtom = atomWithQuery((get) => {
    const isCookieLoggedIn = get(isCookieLoggedInAtom);
    return {
      queryKey: ['getRegulationApi', isCookieLoggedIn],
      queryFn: getRegulationApi,
      select: (res: AxiosResponse<RegulationResponse>): RegulationResponse => {
        // 디버깅 용으로 개발시나 QA시 바꿔서 보기 위한 값
        if (customVaraFlag()) return { regulationStatus: 'VARA_REGULATED', isVaraTemporaryOpen: true };
        return res.data;
      },
    };
  });

  // Alert 노출 후에 UI 를 spot only 에 맞춰서 보여줌
  const isSpotOnlyFromDataAtom = atom((get) => {
    const regulation = get(getUserRegulationAtom);
    const regulationStatus = regulation.data?.regulationStatus;
    const spotOnlyRegulationStatus: Partial<RegulationStatus | undefined>[] = ['VARA_REGULATED'];
    return spotOnlyRegulationStatus.includes(regulationStatus);
  });

  // TODO: [sh] VARA 임시 개방 여부 - 정식 오픈 후 제거
  const isVaraTemporaryOpenAtom = atom((get) => {
    const isSpotOnlyFromData = get(isSpotOnlyFromDataAtom);
    const regulation = get(getUserRegulationAtom);
    return isSpotOnlyFromData && regulation.data?.isVaraTemporaryOpen;
  });

  // Alert 노출 후에 UI 를 spot only 에 맞춰서 보여줌
  const isSpotOnlyAtom = atom((get) => {
    const isShowAlert = get(isShowAlertAtom);
    const isSpotOnlyFromData = get(isSpotOnlyFromDataAtom);
    return isShowAlert && isSpotOnlyFromData;
  });

  return {
    isSpotOnlyAtom,
    isSpotOnlyFromDataAtom,
    isShowAlertAtom,
    isVaraTemporaryOpenAtom,
    getUserRegulationAtom,
  };
});

userRegulationBunja.debugLabel = 'userRegulationBunja';
